import EntryExitDashboard from "./components/EntryExitDashboard";

const routes = {
  path: "dashboard/entry-exit-dashboard",
  children: [{ path: "", element: <EntryExitDashboard /> }],
};

export default routes;
